import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col, Button } from "react-bootstrap";

// Components
import Pokemon from "../components/Pokemon";
import Loader from "../components/Loader";

const Homepage = () => {
  const [pokemon, setPokemon] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pokemonPerPage] = useState(8); // Number of Pokémon you want to display per page

  const getPokemonList = async (page) => {
    setLoading(true);
    let start = (page - 1) * pokemonPerPage + 1;
    let pokemonArray = [];
    for (let i = start; i < start + pokemonPerPage; i++) {
      pokemonArray.push(await getPokemonData(i));
    }
    setPokemon(pokemonArray);
    setLoading(false);
  };

  const getPokemonData = async (id) => {
    const res = await axios.get(`https://pokeapi.co/api/v2/pokemon/${id}`);
    return res;
  };

  useEffect(() => {
    getPokemonList(currentPage);
  }, [currentPage]);

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1)); // Prevent going below page 1
  };

  const handleNext = () => {
    setCurrentPage((prev) => prev + 1); // Assume there is  a next page)
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Row>
            {pokemon.map((p) => (
              <Col key={p.data.name} xs={12} sm={6} md={4} lg={3} xl={3}>
                <Pokemon pokemon={p.data} />
              </Col>
            ))}
          </Row>
          <Row className="justify-content-center mt-4">
            <Col xs="auto">
              <Button onClick={handlePrevious} disabled={currentPage === 1}>
                Previous
              </Button>
            </Col>
            <Col xs="auto">
              <Button onClick={handleNext}>Next</Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default Homepage;
